import { render, staticRenderFns } from "./EditLabel.vue?vue&type=template&id=68ef1623&scoped=true&"
import script from "./EditLabel.vue?vue&type=script&lang=ts&"
export * from "./EditLabel.vue?vue&type=script&lang=ts&"
import style0 from "./EditLabel.vue?vue&type=style&index=0&id=68ef1623&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ef1623",
  null
  
)

export default component.exports